import { Layout } from 'antd';
import { Navigate } from 'react-router-dom';

import useAuth from '@hooks/use-auth';
import Widget from './Widget';

const CarrierLogsPage = () => {
  let { data } = useAuth();

  if (
    data?.permissions.length === 1 &&
    !['superuser', 'manager'].includes(data.permissions[0])
  ) {
    return <Navigate to="/" replace />;
  }

  return (
    <Layout style={{ height: '100%' }}>
      <Widget />
    </Layout>
  );
};

export default CarrierLogsPage;
